import React, {useEffect, useState} from 'react';
import classnames from 'classnames';
import DefaultButton from '../default-button/default-button';
import './date-range-picker-dropdown.scss';
import Text from '../text/text';
import DatePicker from 'react-datepicker';

export interface IProps {
    label: string;
    onApply: (items: Date[]) => void;
    classNames?: string | null;
    value?: Date[] | string[];
    withoutHighlight?: boolean;
    monthsShown?: number;
    minDate?: Date;
}

const DateRangePickerDropdown = (props: IProps) => {
    const {
        label,
        classNames,
        onApply,
        withoutHighlight,
        value,
        monthsShown = 2,
        minDate
    } = props;

    const [isOpen, setIsOpen] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    useEffect(() => {
        setStartDate(value[0] ? new Date(value[0]) : null);
        setEndDate(value[1] ? new Date(value[1]) : null);
    }, [value]);

    const onDropdownClick = () => {
        setIsOpen(!isOpen);
    };

    const onReset = () => {
        setStartDate(null);
        setEndDate(null);
        onApply([]);
        setIsOpen(false);
    };

    const onChange = (dates: Date[]) => {
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
        if (start && end) {
            onApply(dates);
            setIsOpen(false);
        }
    };

    const isResetButtonDisabled = !startDate || !endDate;

    return (
        <div className={classnames('date-range-picker-dropdown', classNames)}>
            <div
                onClick={onDropdownClick}
                className={classnames('cell-header-btn', {'cell-header-btn--active': isOpen ||
                        (!withoutHighlight && startDate && endDate)})}
            >
                <Text message={label}/>
            </div>
            {isOpen &&
                <>
                    <div className="date-range-picker-dropdown__overlay" onClick={() => setIsOpen(false)}/>
                    <div className="date-range-picker-dropdown__content">
                        <div className="date-range-picker-dropdown__datepicker">
                            <DatePicker
                                selected={startDate}
                                onChange={onChange}
                                startDate={startDate}
                                endDate={endDate}
                                monthsShown={monthsShown}
                                minDate={minDate}
                                selectsRange
                                inline
                                disabledKeyboardNavigation={true}
                            />
                        </div>
                        <div className="date-range-picker-dropdown__button-bar">
                            <DefaultButton
                                modifier="cancel"
                                text="Reset"
                                onClick={onReset}
                                className="read-only-textarea__controls-button"
                                disabled={isResetButtonDisabled}
                            />
                        </div>
                    </div>
                </>
            }
        </div>
    );
};

export default DateRangePickerDropdown;
